<template>
	<!-- <div :style="'height:700px; width:' + operation == 'S' ? '1200px;' : '900px;'" v-on:keyup.esc="close()"> -->
	<div style="width:1000px;" v-on:keyup.esc="close()">
		<div class="left_option">
			<em v-if="false" class="lt_text">Item {{ headers.class }}</em>
			<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" v-on:ok="search()" /> </span>

			<span class="int_type half_int mgr_10">
				<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" ref="spkeyword" autofocus autocomplete="off" @keydown.enter="search()" /> -->
				<AC
					ref="ac"
					v-model.trim="keyword"
					:initialDisplay="keyword"
					:source="selectClasses"
					:focusOnAC="focusOnAC"
					@result="test2"
					@nothingSelected="searchKeyword"
					@selected="selectClass"
					@enter="acEnter"
					@focus="acFocus"
					results-display="code_name"
					placeholder="Item / Class Name or Code"
				>
				</AC>
			</span>

			<span class="int_type mgr_5">
				<currency-input
					type="text"
					style="width:120px;"
					v-model.trim="batchQuantity"
					:precision="0"
					:allow-negative="false"
					class="int_type al_right"
					placeholder="Qty for checked"
					@focus="$event.target.select()"
					@keyup.enter="batchApplyQuantity()"
				/>
			</span>
			<a href="javascript:;" type="button" class="search_bt mgr_15" @click="batchApplyQuantity()">Apply</a>

			<a v-if="imageFileName" href="javascript:;" type="button" class="gray_bt2" @click="viewImage()">View Image</a>
			<img v-img="{ sourceButton: false }" ref="image" v-if="imageFileName" :src="getImageUrl()" alt="" style="cursor: zoom-in;max-height:22px;max-width:30px;height:auto;width:auto;" />
		</div>
		<div class="view_inner">
			<!-- <span class="int_type mm_int"><input type="text" class="mm_int" v-model="filter" ref="spFilter" placeholder="Filter by name" autofocus autocomplete="off"/></span>
			<a href="javascript:;" class="gray_bt" @click="clear()">Clear</a> -->
			<div class="fixed-table-container" ref="div_wrapper_parent" style="height:590px;">
				<div class="table-wrapper" ref="div_wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:30px;">
									<div class="th-text "><input type="checkbox" @change="selectAll()" v-model="allSelected" /></div>
								</th>
								<th style="text-align:center;width:30px;"><div class="th-text">#</div></th>
								<th style="text-align:center;width:90px;">
									<div class="th-text">{{ headers.class }}</div>
								</th>
								<th style="text-align:center;"><div class="th-text ">Name</div></th>
								<th style="text-align:center;width:90px;"><div class="th-text">Color</div></th>
								<th style="text-align:center;width:40px;"><div class="th-text">PCS</div></th>
								<th v-if="user.company_id == 'newjigu'" style="text-align:center;width:240px;"><div class="th-text">Pre-Defined Qty</div></th>
								<th style="text-align:center;width:50px;"><div class="th-text ">Qty.</div></th>
								<th style="text-align:center;width:40px;"><div class="th-text">On-H.</div></th>
								<th style="text-align:center;width:40px;"><div class="th-text">Avail</div></th>
								<th style="text-align:center;width:40px;"><div class="th-text">OnB.</div></th>
								<th style="text-align:center;width:85px;"><div class="th-text">Arr Date</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, index) in items" v-bind:key="item.item_id">
								<td v-if="operation == 'S'" class="al_center"><input type="checkbox" v-model="item.selected2" /></td>
								<td class="al_right">{{ index + 1 }}</td>
								<td>{{ item.class_code }}</td>

								<!-- <td class="truncate"> -->
								<td class="al_left truncate">
									<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
									{{ item.name }}
									<!-- <template v-if="item.first_sale"> <font color="blue">FS!!</font></template> -->
								</td>
								<td>{{ item.color_code }}</td>
								<td class="al_right">{{ item.packing }}</td>

								<td v-if="user.company_id == 'newjigu'" class="al_center">
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 1)">1</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 5)">5</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 10)">10</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 20)">20</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 50)">50</a>
									<a href="javascript:;" type="button" class="gray_bt3" style="margin-left:5px;" @click="clearQuantity(item)">CLR</a>
								</td>

								<td class="al_right">
									<!-- <money type="text" v-model="item.quantity" :ref="'quantity'" class="r_int long_type al_right" v-on:keyup.down="test()" /> -->
									<currency-input
										type="text"
										ref="quantity"
										v-model.trim="item.quantity"
										:precision="0"
										:allow-negative="operation == 'N' ? true : false"
										class="r_int long_type al_right"
										@keydown.down.prevent="keyDown('quantity', index)"
										@keydown.up.prevent="keyUp('quantity', index)"
										@keydown.enter.prevent="keyDown('quantity', index)"
										@focus="$event.target.select()"
										@keydown.ctrl.enter.prevent="ok()"
									/>
								</td>

								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
								<td class="al_right">{{ item.available_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
								<td class="al_left">{{ item.arrival_date }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="view_bottom_bt">
				<span v-if="total_quantity != 0" style="padding-right:25px">
					Total Quantity :
					<b>{{ total_quantity | commaSeparated }}</b></span
				>
				<a href="javascript:;" type="button" class="search_bt" @click="ok()">Add (Ctrl + Enter)</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal" :draggable="false" @keydown.esc.prevent="test()" style="z-index:3000">
			<template slot="title">Select Item {{ headers.class }}</template>
			<template slot="body">
				<ItemClassPopup :initialKeyword="keyword" :code_only="false" :operation="operation" v-on:close="closeModal()" @close="popupCanceled" @cancel="popupCanceled" @set-item-class2="setItemClass" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
//import { apiSelectItemClassList } from '@/api/item/class.js';
import { apiSelectItemClass } from '@/api/item/class.js';
import { apiSelectItemList } from '@/api/item/master.js';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import Modal from '@/components/common/Modal';
import ItemClassPopup from '@/components/common/ItemClassPopup';
import AC from '@/components/common/AC';

export default {
	data: function() {
		return {
			items: [],
			filter: null,

			//classes: [],

			itemClass: null,
			className: null,
			keyword: '',
			prevKeyword: '',

			imageFileName: null,

			showModal: false,

			allSelected: false,
			batchQuantity: null,
		};
	},
	computed: {
		// items() {
		// 	//inputSelectOnClick();
		// 	var vm = this;
		// 	if (vm.filter) return this.initialItems.filter(m => m.name.toLowerCase().includes(vm.filter.toLowerCase()));
		// 	else return this.initialItems;
		// },
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		total_quantity: function() {
			var tot = 0;
			this.items.forEach(i => {
				if (i.quantity) tot += i.quantity;
			});
			return tot;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		initialItems: Array,
		initialItemClass: String,
		initialClassName: String,
		initialKeyword: String,

		ship_to_code: String,
		vendor_code: String,

		operation: {
			type: String,
			default: 'S', // S : Sales, P : Purchase
		},

		invoice_type: {
			type: String,
			default: 'S', // S :Sales, R : Return
		},

		includeInactive: {
			type: Boolean,
			default: false,
		},
		focusOnAC: {
			type: Boolean,
		},
	},
	components: {
		ItemClassSelect,
		Modal,
		ItemClassPopup,
		AC,
	},
	methods: {
		clearQuantity(item) {
			item.quantity = null;

			this.$forceUpdate();
		},
		addQuantity(item, qty) {
			if (item.quantity > 0) item.quantity += qty;
			else item.quantity = qty;

			this.$forceUpdate();
		},
		viewImage() {
			this.$refs.image.click();
		},
		getImageUrl() {
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + this.imageFileName;
			return url;
		},
		test() {
			console.log('test');
		},
		batchApplyQuantity() {
			var vm = this;
			this.items
				.filter(i => i.selected2)
				.forEach(i => {
					i.quantity = vm.batchQuantity;
					i.selected2 = false;
				});

			this.$forceUpdate();
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected2 = vm.allSelected;
			});
		},
		// clickClass(c) {
		// 	this.itemClass = c.code;
		// 	this.keyword = null;

		// 	this.showModal = false;

		// 	this.search();
		// },
		// closeModalItems() {
		// 	this.showModal = false;
		// },
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.operation == 'S') url += '&for_sale_yn=Y';
			if (this.invoice_type == 'R') url += '&for_return_yn=Y';
			//url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			//this.$refs.ac.clear();
			//this.keyword = '';
			//console.log(c);
			this.prevKeyword = this.$refs.ac.$el.children[0].children[1].children[0].value;
			//console.log(this.prevKeyword);
			this.itemClass = c.selectedObject.code;
			this.className = c.selectedObject.name;
			this.imageFileName = c.selectedObject.image_file_name;
			this.search();
			//console.log(this.$refs.ac);
			//console.log(str);
		},
		searchKeyword(keyword) {
			//if (!keyword) keyword = this.prevKeyword;

			//console.log(keyword);
			this.keyword = keyword;
			this.prevKeyword = keyword;
			this.search();
			this.$refs.ac.clear();
		},
		acFocus() {
			if (this.focusOnAC) this.$emit('forcedFocusOnAC');
		},
		acEnter() {
			//this.prevKeyword = this.$refs.ac.$el.children[0].children[1].children[0].value;
			//console.log('Hmmm', this.$refs.ac.$el.children[0].children[1].children[0].value);
			//console.log(this.$refs.ac);
			//console.log(this.$refs.ac.$el.firstChild.children[1].children[0]);
		},

		test2(keyword) {
			console.log('input keyword', keyword);
		},

		keyDown(ref, index) {
			if (index < this.items.length - 1) {
				//console.log(this.$refs[ref][index + 1]);
				//console.log(this.$refs[ref][index + 1].$el.offsetParent.offsetTop);
				this.$refs[ref][index + 1].$el.select();
				//document.body.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop;
				//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop;
				//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop + this.$refs[ref][index + 1].$el.offsetParent.Height - this.$refs.div_wrapper.Height;
				//this.$refs[ref][index + 1].$el.scrollIntoView();
				//this.$nextTick(() => this.$refs[ref][index + 1].$el.scrollIntoView());
				if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				}
				//console.log(this.$refs.div_wrapper_parent.scrollHeight);
				//console.log(this.$refs.div_wrapper.scrollTop, this.$refs[ref][index + 1].$el.offsetParent.offsetTop, this.$refs[ref][index + 1].$el.offsetParent.scrollHeight);
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				this.$refs.div_wrapper.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		keyEnter(ref, index) {
			if (ref == 'quantity' && index < this.items.length - 1) this.$refs['quantity'][index + 1].$el.select();
		},
		clear() {
			this.filter = null;
			//inputSelectOnClick();
		},
		closeModal() {
			this.showModal = false;
		},
		setItemClass(itemClass) {
			this.search2(itemClass.code, null);
		},
		popupCanceled() {
			//console.log('canceld');
			//this.keyword = this.prevKeyword;
			//this.setKeywordFocus();
		},
		async search() {
			//console.log(this.operation)
			//console.log('keyword', this.keyword, 'class', this.itemClass);
			if (this.keyword || this.itemClass) {
				if (!this.itemClass && this.keyword.length < 2) {
					this.$toast.error('Search keyword is too short');
					return;
				} else if (!this.itemClass) {
					//console.log('class popup');
					this.showModal = true;
				} else {
					await this.search2(this.itemClass, this.keyword);
					this.itemClass = null;
				}
			} else {
				this.$toast.error(`Item ${this.headers.class} and Keyword are Empty`);
			}
		},
		async search2(ic, kw) {
			var param = {
				class_code: ic,
				keyword: kw,

				include_available: true,
				include_on_board: true,
			};

			if (this.operation == 'S') {
				param.for_sale = true;
				param.ship_to_code = this.ship_to_code;
			}

			if (this.operation == 'S' && this.invoice_type == 'R') {
				param.for_return = true;
			}

			if (this.includeInactive) param.include_inactive = true;

			const { data } = await apiSelectItemList(param);

			// if (data.classList) {
			// 	this.classes = data.classList;
			// 	this.showModal = true;
			// }

			if (data.itemList.length > 0) {
				this.items = data.itemList;
				this.$nextTick(function() {
					this.$refs['quantity'][0].$el.select();
					//this.$refs.ac.clear();
					//console.log(this.prevKeyword);
				});

				//첫번째 input에 focus 두기
			} else {
				this.items = [];
				this.$toast.error('No item is found');
			}

			//this.keyword = null;
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
			this.className = null;
			this.items = [];
			//this.$refs.ac.clear();
			this.setKeywordFocus();
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		ok() {
			//var selectedItems = this.items.filter(item => item.quantity && (this.operation == 'N' || item.net_price || item.net_price === 0));
			//console.log(this.items.filter(item => item.quantity && this.operation == 'N'));
			//var selectedItems = this.items.filter(item => item.quantity && this.operation == 'N');
			var selectedItems = this.items.filter(item => item.quantity > 0 || (this.operation == 'N' && item.quantity < 0));
			if (selectedItems.length > 0) {
				this.$emit('set-items', selectedItems);
				this.$toast.success('Item(s) added.');
				this.reset();
			} else {
				this.$toast.error('No item(s) to add');
			}
			//this.close();
			this.items = [];

			//this.$refs.ac.focus();
			this.setKeywordFocus();
			this.$refs.ac.$el.children[0].children[1].children[0].value = this.prevKeyword;
			//this.keyword = this.prevKeyword;
			//this.$refs.ac.$el.children[0].children[1].children[0].dispatchEvent(new Event('keypress'));
		},
		setKeywordFocus() {
			this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		keyInput(ev) {
			//console.log(ev);
			if (ev.keyCode == 27) this.close();
		},
		async getClassInfo(class_code) {
			const { data } = await apiSelectItemClass({ code: class_code });
			this.imageFileName = data.itemClass.image_file_name;
		},
	},
	created() {
		//console.log('initial itemn class', this.initialItemClass);
		//console.log('initial itemn class', this.initialItemClass);
		//console.log('initial keyword', this.initialKeyword);
		this.items = this.initialItems;
		this.itemClass = this.initialItemClass;
		this.className = this.initialClassName;
		this.keyword = this.initialKeyword;

		//console.log(this.operation, this.invoice_type);

		//console.log('item class', this.itemClass);
		//console.log('keyword', this.keyword);
		if (this.itemClass) this.getClassInfo(this.itemClass);

		if (this.keyword || this.itemClass) {
			this.search();
		}
	},
	mounted() {
		inputSelectOnClick();
		//console.log('item class 2', this.itemClass);
		//console.log('keyword 2', this.keyword);

		// if (this.initialItems.length > 0) {
		// 	setTimeout(() => {
		// 		this.$refs['quantity'][0].$el.focus();
		// 	}, 10);
		// }

		// this.$nextTick(function() {
		// 	if (this.initialItems.length > 0) {
		// 		this.$refs['quantity'][0].$el.focus();
		// 	}
		// });

		setTimeout(() => {
			//console.log(this.$refs.ac.$el.children[0].children[1].children[0]);
			//this.$refs.spkeyword.focus();
			//this.$refs.ac.focus();
			this.setKeywordFocus();
		}, 10);

		// var vm = this;
		// window.addEventListener('keyup', function(ev) {
		// 	vm.keyInput(ev);
		// });

		var vm = this;

		window.addEventListener('keyup', function(ev) {
			//self.myMethod(ev); // declared in your component methods
			if (ev.code == 'Escape') vm.close();
		});

		//console.log(this.initialItems);
	},
};
</script>

<style></style>
